import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import objectPath from 'object-path';
import { NotificationBanner } from '@components/NotificationBanner';
import { useHtmlClassService } from '@metronic/layout/_core/MetronicLayout';
import { selectGlobalBannerNotification } from '@selectors';
import { Topbar } from './Topbar';

export function Header() {
  const uiService = useHtmlClassService();
  const globalBannerNotification = useSelector(selectGlobalBannerNotification);

  const layoutProps = useMemo(
    () => ({
      headerClasses: uiService.getClasses('header', true),
      headerAttributes: uiService.getAttributes('header'),
      headerContainerClasses: uiService.getClasses('header_container', true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        'header.menu.self.display',
      ),
    }),
    [uiService],
  );

  return (
    <>
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        <div
          className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-end`}
        >
          <Topbar />
        </div>
      </div>
      {globalBannerNotification ? (
        <NotificationBanner notifications={[globalBannerNotification]} />
      ) : null}
    </>
  );
}
